$(document).ready(function(){ 

  // 設定した日付の間だけに実行する
  // 注意！「月」は０から始まる（１月 → ０）
  var today = new Date().getTime();
  var overlayStart =　new Date(2018, 11, 1).getTime();
  var overlayEnd = new Date(2019, 0, 15).getTime();

  if (today >= overlayStart && today <= overlayEnd) {
    var $venoOverlay = $('#overlay-special').venobox({
      border: '0',
      bgcolor: '#A8D4D7',
      closeBackground: '#fff',
      closeColor: '#aaa',
      overlayColor: 'rgba(33, 136, 196, 0.8)',
      cb_post_close: function() { // 閉じるボタンが押された後に
        // js-cookieというプラグインの設定
        // https://github.com/js-cookie/js-cookie/tree/latest#cookie-attributes
        Cookies.set('overlay-close', '閉じるボタンを押した', {
          expires: 1 // Cookieの有効期限（日）
        }); 
      },
    });

    if (!Cookies.get('overlay-close')) { // キャッシュに『overlay-close』というCookieがない場合
      $venoOverlay.trigger('click'); // ページ読み込み時に全画面バナーが表示される。
    } else { // キャッシュに『overlay-close』というCookieがある場合
    // ページ読み込み時に全画面バナーが表示されない。
    }
  }
});